import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, concatMap, from, map, Observable, of, toArray } from "rxjs";
import { Structure } from "../models/structure.model";
import { ICategory } from "../models/category";
import { environment } from '../../environments/environment';

@Injectable()
export class StructureService {
  private baseUrl = environment.cms_base_url;

  private sharedData = new BehaviorSubject<any>([]);

  public currentData$ = this.sharedData.asObservable();

  isFilterEventEmitter = new EventEmitter<any>();

  constructor(private http: HttpClient) { }

  getLayoutFile(json: string | null) {
    if (json === null) json = "page-test";
    return this.http.get<Structure>("/assets/mock/" + json + ".json").pipe(map((json) => json));
  }

  getLayout(page: string | null, hostname: string, skipErrorInterceptor?: boolean) {
    let headers = new HttpHeaders()
    // Skip toastService error handler
    if (skipErrorInterceptor) {
      headers = headers.set('X-Skip-Error-Interceptor', 'true')
    }

    return this.http
      .post<Structure>(`${this.baseUrl}/siep-cms/page/`, {
        slug: page,
        domain: hostname,
      }, { headers })
      .pipe(map((json) => json));
  }

  checkIfLayoutExists(page: string | null, hostname: string, skipErrorInterceptor?: boolean) {
    let headers = new HttpHeaders()
    // Skip toastService error handler
    if (skipErrorInterceptor) {
      headers = headers.set('X-Skip-Error-Interceptor', 'true')
    }
    return this.http
      .post<Structure>(`${this.baseUrl}/siep-cms/page/checkPage`, {
        slug: page,
        domain: hostname,
      }, { headers })
      .pipe(map((json) => json));
  }

  setData(json: string | null) {
    if (json === null) json = "data-test-1";
    let endpoint = (json.match(/^http?:\/\//)) ? json : environment.api_base_url + json;
    //let endpoint = json.match(/^http?:\/\//) ? json : "/assets/mock/" + json + ".json";
    this.http
      .get<any>(endpoint)
      .pipe(map((json) => json))
      .subscribe((data) => {
        this.sharedData.next(data);
      });
  }

  addData(model: any, endpoint: string) {
    this.http
      .post<any>(environment.api_base_url + endpoint, model)
      .pipe()
      .subscribe((data) => {
        this.sharedData.next(data);
      });
  }

  // PER LA SMART TABLE //
  getDataById(endpoint: string, id?: number): Observable<any[]> {
    const url = id ? `${environment.api_base_url + endpoint}/${id}` : environment.api_base_url + endpoint;
    return this.http.get<any[]>(url);
  }
  getDataTable(endpoint: string, paginationRemote: any): Observable<any[] | any> {
    if (paginationRemote) {
      const queryString = `/paginated?page=${paginationRemote.page ?? 0}&size=${paginationRemote.size ?? 25}&sortBy=${paginationRemote.sortBy ?? 'id'}&sortDirection=${paginationRemote.sortDirection ?? 'DESC'}`;
      endpoint += queryString;
    }
    return this.http.get<any>(environment.api_base_url + endpoint);
  }

  filterDataTable(model: any, endpoint: string, paginationRemote: any): Observable<any[] | any> {
    const payload = {
      ...model,
      ...(paginationRemote ?? {})
    };
    return this.http.post<any>(environment.api_base_url + endpoint + (paginationRemote ? "/paginated" : ""), payload);
  }

  concatDataTable(
    endpoint: string,
    concatEndpoint: string,
    newColumns: ICategory[],
    filterModel?: any,
    callServerCategories?: boolean,
    paginationRemote?: any
  ): Observable<any[]> {
    const fullEndpoint = environment.api_base_url + endpoint + (paginationRemote ? "/paginated" : "");
    const httpRequest = filterModel
      ? this.http.post<any>(fullEndpoint, filterModel)
      : this.http.get<any>(fullEndpoint);

    return httpRequest.pipe(
      concatMap((data) =>
        from(paginationRemote ? data.content : data).pipe(
          concatMap((item: any) => {
            const processItem = (source: any) => {
              newColumns.forEach((col) => {
                const matchingElement = source.find((res: any) => res.vocabularyId === col.id);
                if (matchingElement) {
                  item[col.name] = matchingElement.name;
                }
              });
              return item;
            };
            return callServerCategories
              ? this.getDataById(concatEndpoint!, item.id ?? undefined).pipe(map(processItem))
              : of(processItem(item.categories));
          }),
          toArray()
        )
      )
    );
  }

}
